import { DealStageStatus } from "@enums/common.enum";
import { DealStage } from "@app-types/common.type";
import { ICompanyStage } from "@interfaces/company.interface";
import { IPipelineStageSelectOption } from "./PipelineStageSelect";

interface IPipelineStageBadgeProps {
  stage?: IPipelineStageSelectOption | ICompanyStage | DealStage | null;
  size?: string;
}

export function PipelineStageBadge({ stage, size }: IPipelineStageBadgeProps) {
  if (!stage || !stage.status) {
    return (
      <svg
        width={size || "20"}
        height={size || "20"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16797 10H5.83464M14.168 10H15.8346M9.16797 10H10.8346"
          stroke="#9CA1AF"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    );
  }

  const strokeColor = stage.color || "#D9D9D9";
  switch (stage.status) {
    case DealStageStatus.SHOWN_ON_PIPELINE:
      return (
        <svg
          width={size || "12"}
          height={size || "12"}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V8C12 10.2091 10.2091 12 8 12H4C1.79086 12 0 10.2091 0 8V4Z"
            fill={stage.color}
          />
        </svg>
      );
    case DealStageStatus.NOT_SHOWN_ON_PIPELINE:
      return (
        <svg
          width={size || "12"}
          height={size || "12"}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_3968_67511" fill="white">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V8C12 10.2091 10.2091 12 8 12H4C1.79086 12 0 10.2091 0 8V4Z" />
          </mask>
          <path
            d="M4 1.6H8V-1.6H4V1.6ZM10.4 4V8H13.6V4H10.4ZM8 10.4H4V13.6H8V10.4ZM1.6 8V4H-1.6V8H1.6ZM4 10.4C2.67452 10.4 1.6 9.32548 1.6 8H-1.6C-1.6 11.0928 0.907205 13.6 4 13.6V10.4ZM10.4 8C10.4 9.32548 9.32548 10.4 8 10.4V13.6C11.0928 13.6 13.6 11.0928 13.6 8H10.4ZM8 1.6C9.32548 1.6 10.4 2.67452 10.4 4H13.6C13.6 0.907206 11.0928 -1.6 8 -1.6V1.6ZM4 -1.6C0.907206 -1.6 -1.6 0.907205 -1.6 4H1.6C1.6 2.67452 2.67452 1.6 4 1.6V-1.6Z"
            fill={stage.color}
            mask="url(#path-1-inside-1_3968_67511)"
          />
        </svg>
      );
    case DealStageStatus.PORTFOLIO:
      return (
        <svg
          width={size || "14"}
          height={size || "14"}
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5201 0.640977C6.66034 0.161438 7.33966 0.161436 7.4799 0.640976L8.73336 4.92708C8.78123 5.09077 8.90923 5.21877 9.07292 5.26664L13.359 6.5201C13.8386 6.66034 13.8386 7.33966 13.359 7.4799L9.07292 8.73336C8.90923 8.78123 8.78123 8.90923 8.73336 9.07292L7.4799 13.359C7.33966 13.8386 6.66034 13.8386 6.5201 13.359L5.26664 9.07292C5.21877 8.90923 5.09077 8.78123 4.92709 8.73336L0.640977 7.4799C0.161438 7.33966 0.161436 6.66034 0.640976 6.5201L4.92708 5.26664C5.09077 5.21877 5.21877 5.09077 5.26664 4.92709L6.5201 0.640977Z"
            fill={stage.color}
          />
        </svg>
      );
    default:
      return (
        <svg
          width={size || "12"}
          height={size || "12"}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="6" r="5" stroke={strokeColor} strokeWidth="2" strokeDasharray="3 3" />
        </svg>
      );
  }
}
